export default "__VITE_ASSET__df5a3b92__"